import type { TenantImportRow } from '@einwert/valuation-api-client'
import tenantImportTemplateUrl from './assets/Mieterliste_Vorlage.xlsx?url'
import { createTenantImportWorkbook } from './excel'

export { tenantImportTemplateUrl }

export async function downloadTenantImport(rows: TenantImportRow[], filename: string): Promise<void> {
    const response = await fetch(tenantImportTemplateUrl)
    if (!response.ok) {
        throw new Error('The Excel template could not be loaded.')
    }
    const workbook = await createTenantImportWorkbook(await response.arrayBuffer(), rows)
    const url = URL.createObjectURL(new Blob([workbook], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }))
    const link = document.createElement('a')
    link.href = url
    link.download = `${filename.replace(/\.[^.]+$/, '')}_einwert.xlsx`
    link.click()
    setTimeout(() => URL.revokeObjectURL(url), 1000)
}
